import React, { useState ,useEffect} from "react";
import { Button, Form, Input, message } from "antd";
import resetpassword from "../Assets/Onboardingimages/reset-password.png";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom"

import "../App.css";
import { URL } from "../helper/Mainurl";
import { HeaderSection } from "./HeaderSection";
import { FooterSection } from "./FooterSection";

const ResetPassword = () => {
      const navigate = useNavigate()
      // const [searchParams] = useSearchParams();
      const { token } = useParams();      // const token = "XOCwBbHCLExTGatqaFbNBLgu8WzE4huMqEEEjExmSPWSXikWGGuHnqm3ElUE"; // Get token from URL
      console.log("token:::::::",token)


    
  const [form] = Form.useForm();
  const [isSuccess, setIsSuccess] = useState(false); // State to track success
  // const [isTokenValid, setIsTokenValid] = useState(null); // Track token validity


  const handleRedirect =()=>{
    navigate('/')

  }

  useEffect(() => {
    if (!token) {
      message.error("Invalid or expired reset link!");
      // navigate("/login");
      return;
    }

    const validateToken = async () => {
      try {
        const response = await fetch(`https://quelld.webdezign.uk/reset-password/${token}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        console.log("response::::::",response)

        
      } catch (error) {
        console.error("Error validating token:", error);
       }
    };

    validateToken();
  }, [token, navigate]);

  

  const handleClick = async (values) => {
    const payload = {
        new_password: values.new_password,
        password_confirmation:values.password_confirmation,
        // token: token, // Include the token from URL

     };
    try {
      const response = await fetch(`${URL}/reset-password/${token}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          // Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
       });
       const data = await response.json();

  
  if (data.message === "Password reset successfully!") {
    message.success("Password reset successfully...");
    setIsSuccess(true);
  } else {
    message.error(data.message || "Password reset failed!");
  }
    } catch {}
  };


   

  return (
    <div style={{height:'100%',overflow:'auto'}}>
      <HeaderSection/>
      <div className=" ">

      <div className='login-page'>
        <div className='signup-image'>
          <img src='/quelld-signup.png' className='signup-image' />
        </div>
        {!isSuccess ? ( // Conditionally render form or success image
          <>
            <div style={{ fontSize: "28px", justifyContent: "center", display: "flex", fontWeight: "500", paddingTop: "20%", paddingBottom: "8px" }}>Set new password </div>
            <div style={{ fontSize: "16px", justifyContent: "center", display: "flex", color: "#767A83", textAlign: "center" }}>Create a strong new password with at least 8 characters for the account with the email quellduser@gmail.com </div>

            <div style={{ marginTop: "48px" }}>
              <Form form={form} layout='vertical' onFinish={handleClick}>
                <Form.Item
                  name='new_password'
                  rules={[
                    { required: true, message: "Please enter your password!" },
                    {
                      pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
                      message: "Password must have 8+ characters, 1 uppercase, 1 number, and 1 special character!",
                    },
                  ]}
                >
                  <div className='floating-label'>
                    <Input.Password placeholder=' ' />
                    <label>New Password</label>
                  </div>
                </Form.Item>
                <Form.Item
                  name='password_confirmation'
                  dependencies={["password"]}
                  rules={[
                    { required: true, message: "Please enter your confirm password!" },
                    {
                      pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
                      message: "Password must have 8+ characters, 1 uppercase, 1 number, and 1 special character!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("The new password that you entered do not match!"));
                      },
                    }),
                  ]}
                >
                  <div className='floating-label'>
                    <Input.Password placeholder=' ' />
                    <label>Confirm Password</label>
                  </div>
                </Form.Item>
                <div style={{ paddingTop: "15px" }}>
                  <Button type='primary' htmlType='submit' style={{ width: "394px", height: "52px",marginBottom:'30px' }}>
                    Continue
                  </Button>
                </div>
              </Form>
            </div>
          </>
        ) : (
          <>
            <div className='signup-image'>
              <img src={resetpassword} width={248} />
            </div>
            <div style={{ fontSize: "24px", justifyContent: "center", display: "flex", fontWeight: "500", paddingTop: "20%", paddingBottom: "8px" }}>Password update successful </div>
            <div style={{ fontSize: "14px", justifyContent: "center", display: "flex", color: "#767A83", textAlign: "center" }}>Password changed successfully. You may now Sign in with your new password </div>
            <a style={{ fontSize: "14px", justifyContent: "center", display: "flex", color: "#9A4FE0", textAlign: "center",marginTop:'48px',fontWeight: "500" ,textDecoration:'none' }} onClick={handleRedirect}>Sign in to Quelld</a>
          </>
        )}
      </div>
</div>

      <FooterSection/>
    </div>
  );
};

export default ResetPassword;
